// extracted by mini-css-extract-plugin
export default {"retangle":"marcas_retangle__FIc+H"};